import ky, {} from "ky";
export let api = ky.create({
    hooks: {
        beforeError: [
            (error) => {
                console.error("API Error:", error);
                return error;
            },
        ],
    },
});
export function updateApiOptions(options) {
    api = api.extend(options);
}
//# sourceMappingURL=api.js.map